import HorizontalReportActivity from "./HorizontalReportActivity";
export default HorizontalReportActivity;